<template>
	<svg id="svg_8372f8b1158bb6937d68443eac5bef53_id_0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><title>icon</title><path class=" svg_8372f8b1158bb6937d68443eac5bef53_class_0_0" d="M154,37V19a6,6,0,0,0-6-6H52a6,6,0,0,0-6,6V37Z"></path><path class=" svg_8372f8b1158bb6937d68443eac5bef53_class_1_0" d="M184,49H16a6,6,0,0,0-6,6v84a6,6,0,0,0,6,6H34V103A18,18,0,0,1,52,85h96a18,18,0,0,1,18,18v42h18a6,6,0,0,0,6-6V55A6,6,0,0,0,184,49ZM172,73a6,6,0,1,1,6-6A6,6,0,0,1,172,73Z"></path><path class=" svg_8372f8b1158bb6937d68443eac5bef53_class_2_0" d="M148,97H52a6,6,0,0,0-6,6v72a6,6,0,0,0,6,6h96a6,6,0,0,0,6-6V103A6,6,0,0,0,148,97Zm-24,60H76a6,6,0,0,1,0-12h48a6,6,0,0,1,0,12Zm0-24H76a6,6,0,0,1,0-12h48a6,6,0,0,1,0,12Z"></path><path class=" svg_8372f8b1158bb6937d68443eac5bef53_class_3_0" d="M76,157h48a6,6,0,0,0,0-12H76a6,6,0,0,0,0,12Z"></path><path class=" svg_8372f8b1158bb6937d68443eac5bef53_class_3_0" d="M76,133h48a6,6,0,0,0,0-12H76a6,6,0,0,0,0,12Z"></path></svg>
</template>

<script>
	export default {
		name: "PrintIcon"
	};
</script>

<style lang="scss" scoped>
	.svg_8372f8b1158bb6937d68443eac5bef53_class_0_0{fill:#4d4d4d;}
	.svg_8372f8b1158bb6937d68443eac5bef53_class_1_0{fill:gray;}
	.svg_8372f8b1158bb6937d68443eac5bef53_class_2_0{fill:#fff;}
	.svg_8372f8b1158bb6937d68443eac5bef53_class_3_0{fill:#666;}
</style>
